<template>
  <section class="bg-dark border-bottom">
    <div class="container">
      <div class="row py-3 py-md-4">
        <div class="col-12">
          <form class="form-inline flex-nowrap" @submit.stop.prevent="() => {}">
            <input
              v-model="search"
              class="col form-control form-control-lg mr-sm-2 d-inline-block"
              type="search"
              :placeholder="content.search"
              :aria-label="content.search"
              @input="onSearchTermChange"
            />

            <Spinner v-show="isLoading" class="position-absolute spinner" />
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import debounce from 'lodash/debounce';
import { createNamespacedHelpers } from 'vuex';

import Spinner from '@/src/components/Spinner.vue';

import { action, mutation } from './store';

const { mapGetters } = createNamespacedHelpers('search');

export default {
  name: 'SearchBox',

  components: {
    Spinner,
  },

  data() {
    return {
      search: '',
    };
  },

  computed: {
    ...mapGetters(['isLoading', 'searchTerm', 'content']),
  },

  watch: {
    searchTerm: {
      immediate: true,
      handler(newValue, _) {
        this.search = newValue;
      },
    },
  },

  methods: {
    onSearchTermChange: debounce(async function () {
      this.$store.commit(mutation('SET_SEARCH_TERM'), this.search);

      await this.$store.dispatch(action('LOAD_SEARCH_RESULTS'));
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
.spinner {
  top: -10px;
  right: 20px;
}
</style>
